var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _c("div", { staticClass: "vx-card" }, [
      _c("div", { staticClass: "vx-card__collapsible-content" }, [
        _c("div", { staticClass: "vx-card__body row" }, [
          _c("div", { staticClass: "col-md-4 col-12" }, [
            _c("h4", { staticClass: "text-primary mb-3" }, [
              _vm._v(" Integraciones ")
            ]),
            _c("div", { staticClass: "input-group mb-3" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search,
                    expression: "search"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "Buscar integración",
                  "aria-label": "Buscar integración",
                  "aria-describedby": "input-search-integration"
                },
                domProps: { value: _vm.search },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.search = $event.target.value
                  }
                }
              })
            ]),
            _c(
              "ul",
              {
                staticClass: "list-group mt-2",
                staticStyle: { "max-height": "80vh", overflow: "auto" }
              },
              [
                _vm._l(_vm.filteredIntegrations, function(integration) {
                  return _c(
                    "li",
                    {
                      key: "integration-" + integration.key,
                      staticClass: "list-group-item integration-row",
                      class: {
                        "active-integration": _vm.isSelected(integration)
                      },
                      attrs: {
                        id: "integration-" + integration.key,
                        "data-cy": "integration-item"
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectIntegration(integration)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-2",
                            attrs: {
                              icon: integration.icon || "LinkIcon",
                              size: "18"
                            }
                          }),
                          _c("div", [
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(_vm._s(integration.name))
                            ]),
                            integration.description
                              ? _c(
                                  "small",
                                  { staticClass: "d-block text-muted" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(integration.description) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      ),
                      _c(
                        "b-badge",
                        {
                          attrs: {
                            variant: _vm.integrationBadge(integration).variant,
                            pill: ""
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.integrationBadge(integration).text) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                !_vm.filteredIntegrations.length
                  ? _c(
                      "li",
                      { staticClass: "list-group-item text-center text-muted" },
                      [_vm._v(" No se encontraron integraciones ")]
                    )
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm.selectedIntegration
            ? _c(
                "div",
                { staticClass: "col-md-8 col-12" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mb-3"
                    },
                    [
                      _c("h4", { staticClass: "text-primary mb-0" }, [
                        _vm._v(
                          " Configuración: " +
                            _vm._s(_vm.selectedIntegration.name) +
                            " "
                        )
                      ])
                    ]
                  ),
                  _vm.selectedIntegration.description
                    ? _c("p", { staticClass: "text-muted" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.selectedIntegration.description) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _vm.selectedIntegration.info
                    ? _c(
                        "b-card",
                        {
                          staticClass: "info-section mb-4",
                          attrs: { "no-body": "" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "info-section__header" },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "InfoIcon", size: "16" }
                              }),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.selectedIntegration.info.title)
                                )
                              ])
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "info-section__body" },
                            [
                              _vm.selectedIntegration.info.description
                                ? _c("p", { staticClass: "text-muted mb-3" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedIntegration.info
                                            .description
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._l(
                                _vm.selectedIntegration.info.groups,
                                function(group) {
                                  return _c(
                                    "div",
                                    { key: group.name, staticClass: "mb-3" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "info-section__group-name"
                                        },
                                        [_vm._v(_vm._s(group.name))]
                                      ),
                                      _vm._l(group.items, function(item) {
                                        return _c(
                                          "div",
                                          {
                                            key: group.name + "-" + item.label,
                                            staticClass: "info-section__item"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "info-section__label"
                                              },
                                              [_vm._v(_vm._s(item.label) + ":")]
                                            ),
                                            _c(
                                              "code",
                                              {
                                                staticClass:
                                                  "info-section__value"
                                              },
                                              [_vm._v(_vm._s(item.value))]
                                            ),
                                            _c("feather-icon", {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value: "Copiar",
                                                  expression: "'Copiar'"
                                                }
                                              ],
                                              staticClass: "info-section__copy",
                                              attrs: {
                                                icon: "CopyIcon",
                                                size: "15"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.copyToClipboard(
                                                    item.value
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                }
                              )
                            ],
                            2
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "form",
                    {
                      staticClass: "w-100",
                      attrs: { "data-vv-scope": "integration" }
                    },
                    [
                      _vm._l(_vm.selectedIntegration.fields, function(field) {
                        return _c(
                          "b-form-group",
                          { key: field.key, attrs: { label: field.label } },
                          [
                            _vm.isSimpleInput(field)
                              ? _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: field.required ? "required" : "",
                                      expression:
                                        "field.required ? 'required' : ''"
                                    }
                                  ],
                                  staticClass: "w-100",
                                  attrs: {
                                    type: _vm.inputType(field),
                                    name: field.key,
                                    placeholder: field.placeholder || "",
                                    "data-vv-as": field.label,
                                    state: _vm.validationState(field)
                                  },
                                  model: {
                                    value: _vm.form.values[field.key],
                                    callback: function($$v) {
                                      _vm.$set(_vm.form.values, field.key, $$v)
                                    },
                                    expression: "form.values[field.key]"
                                  }
                                })
                              : field.type === "textarea"
                              ? _c("b-form-textarea", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: field.required ? "required" : "",
                                      expression:
                                        "field.required ? 'required' : ''"
                                    }
                                  ],
                                  attrs: {
                                    name: field.key,
                                    rows: "3",
                                    placeholder: field.placeholder || "",
                                    "data-vv-as": field.label,
                                    state: _vm.validationState(field)
                                  },
                                  model: {
                                    value: _vm.form.values[field.key],
                                    callback: function($$v) {
                                      _vm.$set(_vm.form.values, field.key, $$v)
                                    },
                                    expression: "form.values[field.key]"
                                  }
                                })
                              : field.type === "select"
                              ? _c("b-form-select", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: field.required ? "required" : "",
                                      expression:
                                        "field.required ? 'required' : ''"
                                    }
                                  ],
                                  attrs: {
                                    name: field.key,
                                    options: field.options || [],
                                    "data-vv-as": field.label,
                                    state: _vm.validationState(field)
                                  },
                                  model: {
                                    value: _vm.form.values[field.key],
                                    callback: function($$v) {
                                      _vm.$set(_vm.form.values, field.key, $$v)
                                    },
                                    expression: "form.values[field.key]"
                                  }
                                })
                              : field.type === "boolean"
                              ? _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: { name: field.key, switch: "" },
                                    model: {
                                      value: _vm.form.values[field.key],
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.values,
                                          field.key,
                                          $$v
                                        )
                                      },
                                      expression: "form.values[field.key]"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.form.values[field.key]
                                            ? "Sí"
                                            : "No"
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c("b-form-input", {
                                  staticClass: "w-100",
                                  attrs: {
                                    name: field.key,
                                    placeholder: field.placeholder || ""
                                  },
                                  model: {
                                    value: _vm.form.values[field.key],
                                    callback: function($$v) {
                                      _vm.$set(_vm.form.values, field.key, $$v)
                                    },
                                    expression: "form.values[field.key]"
                                  }
                                }),
                            field.help
                              ? _c(
                                  "small",
                                  { staticClass: "form-text text-muted" },
                                  [_vm._v(" " + _vm._s(field.help) + " ")]
                                )
                              : _vm._e(),
                            _c("FormError", {
                              attrs: {
                                attributeName: "integration." + field.key,
                                errorsForm: _vm.errors
                              }
                            })
                          ],
                          1
                        )
                      }),
                      !_vm.selectedIntegration.fields ||
                      !_vm.selectedIntegration.fields.length
                        ? _c("div", { staticClass: "text-muted" }, [
                            _vm._v(
                              " Esta integración aún no tiene campos de configuración definidos. "
                            )
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "text-right mt-3" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: _vm.saving,
                                "data-cy": "save-integration"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveIntegration()
                                }
                              }
                            },
                            [
                              _vm.saving
                                ? _c("b-spinner", {
                                    staticClass: "mr-1",
                                    attrs: { small: "" }
                                  })
                                : _vm._e(),
                              _vm._v(" Guardar ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass:
                    "col-md-8 col-12 d-flex align-items-center justify-content-center text-muted",
                  staticStyle: { "min-height": "300px" }
                },
                [
                  _vm._v(
                    " Selecciona una integración para configurar sus valores "
                  )
                ]
              )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }